/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as SystemHealthRouteImport } from './routes/system-health'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SimCardsRouteImport } from './routes/sim-cards'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PsychrometricsRouteImport } from './routes/psychrometrics'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as OrganizationsRouteImport } from './routes/organizations'
import { Route as OauthConsentRouteImport } from './routes/oauth-consent'
import { Route as ExperimentsRouteImport } from './routes/experiments'
import { Route as DevicesRouteImport } from './routes/devices'
import { Route as DeploymentsRouteImport } from './routes/deployments'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as ConfigurationRouteImport } from './routes/configuration'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ApiKeysRouteImport } from './routes/api-keys'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ExperimentsIndexRouteImport } from './routes/experiments.index'
import { Route as DevicesIndexRouteImport } from './routes/devices.index'
import { Route as CalibrationsIndexRouteImport } from './routes/calibrations/index'
import { Route as SupportSettingsRouteImport } from './routes/support_.settings'
import { Route as SupportReportsRouteImport } from './routes/support_.reports'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects_.$projectId'
import { Route as ExperimentsSeasonalClimateRouteImport } from './routes/experiments.seasonal-climate'
import { Route as ExperimentsRegionPostcardsRouteImport } from './routes/experiments.region-postcards'
import { Route as ExperimentsLiveNetworkRouteImport } from './routes/experiments.live-network'
import { Route as ExperimentsComfortStreamsRouteImport } from './routes/experiments.comfort-streams'
import { Route as ExperimentsClimateTapestryRouteImport } from './routes/experiments.climate-tapestry'
import { Route as ExperimentsClimateLoopRouteImport } from './routes/experiments.climate-loop'
import { Route as DevicesReturnToStockRouteImport } from './routes/devices_.return-to-stock'
import { Route as DevicesXtelRouteImport } from './routes/devices.xtel'
import { Route as DevicesLorawanRouteImport } from './routes/devices.lorawan'
import { Route as DevicesDeviceIdRouteImport } from './routes/devices.$deviceId'
import { Route as DeploymentsNewRouteImport } from './routes/deployments_.new'
import { Route as DeploymentsAdoptionRouteImport } from './routes/deployments_.adoption'
import { Route as DeploymentsDeploymentIdRouteImport } from './routes/deployments_.$deploymentId'
import { Route as CustomersCustomerIdRouteImport } from './routes/customers_.$customerId'
import { Route as CustomersContactsRouteImport } from './routes/customers.contacts'
import { Route as CalibrationsCalibrationIdRouteImport } from './routes/calibrations/$calibrationId'
import { Route as SupportCasesCaseIdRouteImport } from './routes/support_.cases.$caseId'
import { Route as DevicesDeviceIdTopologyRouteImport } from './routes/devices_.$deviceId.topology'
import { Route as DeploymentsDeploymentIdAdoptRouteImport } from './routes/deployments_.$deploymentId_.adopt'
import { Route as DeploymentsDeploymentIdVersionsVersionIdRouteImport } from './routes/deployments_.$deploymentId_.versions.$versionId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemHealthRoute = SystemHealthRouteImport.update({
  id: '/system-health',
  path: '/system-health',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SimCardsRoute = SimCardsRouteImport.update({
  id: '/sim-cards',
  path: '/sim-cards',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PsychrometricsRoute = PsychrometricsRouteImport.update({
  id: '/psychrometrics',
  path: '/psychrometrics',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsRoute = OrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth-consent',
  path: '/oauth-consent',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsRoute = ExperimentsRouteImport.update({
  id: '/experiments',
  path: '/experiments',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesRoute = DevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => rootRouteImport,
} as any)
const DeploymentsRoute = DeploymentsRouteImport.update({
  id: '/deployments',
  path: '/deployments',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationRoute = ConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeysRoute = ApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsIndexRoute = ExperimentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExperimentsRoute,
} as any)
const DevicesIndexRoute = DevicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevicesRoute,
} as any)
const CalibrationsIndexRoute = CalibrationsIndexRouteImport.update({
  id: '/calibrations/',
  path: '/calibrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportSettingsRoute = SupportSettingsRouteImport.update({
  id: '/support_/settings',
  path: '/support/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportReportsRoute = SupportReportsRouteImport.update({
  id: '/support_/reports',
  path: '/support/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects_/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsSeasonalClimateRoute =
  ExperimentsSeasonalClimateRouteImport.update({
    id: '/seasonal-climate',
    path: '/seasonal-climate',
    getParentRoute: () => ExperimentsRoute,
  } as any)
const ExperimentsRegionPostcardsRoute =
  ExperimentsRegionPostcardsRouteImport.update({
    id: '/region-postcards',
    path: '/region-postcards',
    getParentRoute: () => ExperimentsRoute,
  } as any)
const ExperimentsLiveNetworkRoute = ExperimentsLiveNetworkRouteImport.update({
  id: '/live-network',
  path: '/live-network',
  getParentRoute: () => ExperimentsRoute,
} as any)
const ExperimentsComfortStreamsRoute =
  ExperimentsComfortStreamsRouteImport.update({
    id: '/comfort-streams',
    path: '/comfort-streams',
    getParentRoute: () => ExperimentsRoute,
  } as any)
const ExperimentsClimateTapestryRoute =
  ExperimentsClimateTapestryRouteImport.update({
    id: '/climate-tapestry',
    path: '/climate-tapestry',
    getParentRoute: () => ExperimentsRoute,
  } as any)
const ExperimentsClimateLoopRoute = ExperimentsClimateLoopRouteImport.update({
  id: '/climate-loop',
  path: '/climate-loop',
  getParentRoute: () => ExperimentsRoute,
} as any)
const DevicesReturnToStockRoute = DevicesReturnToStockRouteImport.update({
  id: '/devices_/return-to-stock',
  path: '/devices/return-to-stock',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesXtelRoute = DevicesXtelRouteImport.update({
  id: '/xtel',
  path: '/xtel',
  getParentRoute: () => DevicesRoute,
} as any)
const DevicesLorawanRoute = DevicesLorawanRouteImport.update({
  id: '/lorawan',
  path: '/lorawan',
  getParentRoute: () => DevicesRoute,
} as any)
const DevicesDeviceIdRoute = DevicesDeviceIdRouteImport.update({
  id: '/$deviceId',
  path: '/$deviceId',
  getParentRoute: () => DevicesRoute,
} as any)
const DeploymentsNewRoute = DeploymentsNewRouteImport.update({
  id: '/deployments_/new',
  path: '/deployments/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DeploymentsAdoptionRoute = DeploymentsAdoptionRouteImport.update({
  id: '/deployments_/adoption',
  path: '/deployments/adoption',
  getParentRoute: () => rootRouteImport,
} as any)
const DeploymentsDeploymentIdRoute = DeploymentsDeploymentIdRouteImport.update({
  id: '/deployments_/$deploymentId',
  path: '/deployments/$deploymentId',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersCustomerIdRoute = CustomersCustomerIdRouteImport.update({
  id: '/customers_/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersContactsRoute = CustomersContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => CustomersRoute,
} as any)
const CalibrationsCalibrationIdRoute =
  CalibrationsCalibrationIdRouteImport.update({
    id: '/calibrations/$calibrationId',
    path: '/calibrations/$calibrationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupportCasesCaseIdRoute = SupportCasesCaseIdRouteImport.update({
  id: '/support_/cases/$caseId',
  path: '/support/cases/$caseId',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesDeviceIdTopologyRoute = DevicesDeviceIdTopologyRouteImport.update({
  id: '/devices_/$deviceId/topology',
  path: '/devices/$deviceId/topology',
  getParentRoute: () => rootRouteImport,
} as any)
const DeploymentsDeploymentIdAdoptRoute =
  DeploymentsDeploymentIdAdoptRouteImport.update({
    id: '/deployments_/$deploymentId_/adopt',
    path: '/deployments/$deploymentId/adopt',
    getParentRoute: () => rootRouteImport,
  } as any)
const DeploymentsDeploymentIdVersionsVersionIdRoute =
  DeploymentsDeploymentIdVersionsVersionIdRouteImport.update({
    id: '/deployments_/$deploymentId_/versions/$versionId',
    path: '/deployments/$deploymentId/versions/$versionId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/api-keys': typeof ApiKeysRoute
  '/auth': typeof AuthRoute
  '/configuration': typeof ConfigurationRoute
  '/customers': typeof CustomersRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/deployments': typeof DeploymentsRoute
  '/devices': typeof DevicesRouteWithChildren
  '/experiments': typeof ExperimentsRouteWithChildren
  '/oauth-consent': typeof OauthConsentRoute
  '/organizations': typeof OrganizationsRoute
  '/profile': typeof ProfileRoute
  '/projects': typeof ProjectsRoute
  '/psychrometrics': typeof PsychrometricsRoute
  '/settings': typeof SettingsRoute
  '/sim-cards': typeof SimCardsRoute
  '/support': typeof SupportRoute
  '/system-health': typeof SystemHealthRoute
  '/users': typeof UsersRoute
  '/calibrations/$calibrationId': typeof CalibrationsCalibrationIdRoute
  '/customers/contacts': typeof CustomersContactsRoute
  '/customers/$customerId': typeof CustomersCustomerIdRoute
  '/deployments/$deploymentId': typeof DeploymentsDeploymentIdRoute
  '/deployments/adoption': typeof DeploymentsAdoptionRoute
  '/deployments/new': typeof DeploymentsNewRoute
  '/devices/$deviceId': typeof DevicesDeviceIdRoute
  '/devices/lorawan': typeof DevicesLorawanRoute
  '/devices/xtel': typeof DevicesXtelRoute
  '/devices/return-to-stock': typeof DevicesReturnToStockRoute
  '/experiments/climate-loop': typeof ExperimentsClimateLoopRoute
  '/experiments/climate-tapestry': typeof ExperimentsClimateTapestryRoute
  '/experiments/comfort-streams': typeof ExperimentsComfortStreamsRoute
  '/experiments/live-network': typeof ExperimentsLiveNetworkRoute
  '/experiments/region-postcards': typeof ExperimentsRegionPostcardsRoute
  '/experiments/seasonal-climate': typeof ExperimentsSeasonalClimateRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/support/reports': typeof SupportReportsRoute
  '/support/settings': typeof SupportSettingsRoute
  '/calibrations/': typeof CalibrationsIndexRoute
  '/devices/': typeof DevicesIndexRoute
  '/experiments/': typeof ExperimentsIndexRoute
  '/deployments/$deploymentId/adopt': typeof DeploymentsDeploymentIdAdoptRoute
  '/devices/$deviceId/topology': typeof DevicesDeviceIdTopologyRoute
  '/support/cases/$caseId': typeof SupportCasesCaseIdRoute
  '/deployments/$deploymentId/versions/$versionId': typeof DeploymentsDeploymentIdVersionsVersionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/api-keys': typeof ApiKeysRoute
  '/auth': typeof AuthRoute
  '/configuration': typeof ConfigurationRoute
  '/customers': typeof CustomersRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/deployments': typeof DeploymentsRoute
  '/oauth-consent': typeof OauthConsentRoute
  '/organizations': typeof OrganizationsRoute
  '/profile': typeof ProfileRoute
  '/projects': typeof ProjectsRoute
  '/psychrometrics': typeof PsychrometricsRoute
  '/settings': typeof SettingsRoute
  '/sim-cards': typeof SimCardsRoute
  '/support': typeof SupportRoute
  '/system-health': typeof SystemHealthRoute
  '/users': typeof UsersRoute
  '/calibrations/$calibrationId': typeof CalibrationsCalibrationIdRoute
  '/customers/contacts': typeof CustomersContactsRoute
  '/customers/$customerId': typeof CustomersCustomerIdRoute
  '/deployments/$deploymentId': typeof DeploymentsDeploymentIdRoute
  '/deployments/adoption': typeof DeploymentsAdoptionRoute
  '/deployments/new': typeof DeploymentsNewRoute
  '/devices/$deviceId': typeof DevicesDeviceIdRoute
  '/devices/lorawan': typeof DevicesLorawanRoute
  '/devices/xtel': typeof DevicesXtelRoute
  '/devices/return-to-stock': typeof DevicesReturnToStockRoute
  '/experiments/climate-loop': typeof ExperimentsClimateLoopRoute
  '/experiments/climate-tapestry': typeof ExperimentsClimateTapestryRoute
  '/experiments/comfort-streams': typeof ExperimentsComfortStreamsRoute
  '/experiments/live-network': typeof ExperimentsLiveNetworkRoute
  '/experiments/region-postcards': typeof ExperimentsRegionPostcardsRoute
  '/experiments/seasonal-climate': typeof ExperimentsSeasonalClimateRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/support/reports': typeof SupportReportsRoute
  '/support/settings': typeof SupportSettingsRoute
  '/calibrations': typeof CalibrationsIndexRoute
  '/devices': typeof DevicesIndexRoute
  '/experiments': typeof ExperimentsIndexRoute
  '/deployments/$deploymentId/adopt': typeof DeploymentsDeploymentIdAdoptRoute
  '/devices/$deviceId/topology': typeof DevicesDeviceIdTopologyRoute
  '/support/cases/$caseId': typeof SupportCasesCaseIdRoute
  '/deployments/$deploymentId/versions/$versionId': typeof DeploymentsDeploymentIdVersionsVersionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/api-keys': typeof ApiKeysRoute
  '/auth': typeof AuthRoute
  '/configuration': typeof ConfigurationRoute
  '/customers': typeof CustomersRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/deployments': typeof DeploymentsRoute
  '/devices': typeof DevicesRouteWithChildren
  '/experiments': typeof ExperimentsRouteWithChildren
  '/oauth-consent': typeof OauthConsentRoute
  '/organizations': typeof OrganizationsRoute
  '/profile': typeof ProfileRoute
  '/projects': typeof ProjectsRoute
  '/psychrometrics': typeof PsychrometricsRoute
  '/settings': typeof SettingsRoute
  '/sim-cards': typeof SimCardsRoute
  '/support': typeof SupportRoute
  '/system-health': typeof SystemHealthRoute
  '/users': typeof UsersRoute
  '/calibrations/$calibrationId': typeof CalibrationsCalibrationIdRoute
  '/customers/contacts': typeof CustomersContactsRoute
  '/customers_/$customerId': typeof CustomersCustomerIdRoute
  '/deployments_/$deploymentId': typeof DeploymentsDeploymentIdRoute
  '/deployments_/adoption': typeof DeploymentsAdoptionRoute
  '/deployments_/new': typeof DeploymentsNewRoute
  '/devices/$deviceId': typeof DevicesDeviceIdRoute
  '/devices/lorawan': typeof DevicesLorawanRoute
  '/devices/xtel': typeof DevicesXtelRoute
  '/devices_/return-to-stock': typeof DevicesReturnToStockRoute
  '/experiments/climate-loop': typeof ExperimentsClimateLoopRoute
  '/experiments/climate-tapestry': typeof ExperimentsClimateTapestryRoute
  '/experiments/comfort-streams': typeof ExperimentsComfortStreamsRoute
  '/experiments/live-network': typeof ExperimentsLiveNetworkRoute
  '/experiments/region-postcards': typeof ExperimentsRegionPostcardsRoute
  '/experiments/seasonal-climate': typeof ExperimentsSeasonalClimateRoute
  '/projects_/$projectId': typeof ProjectsProjectIdRoute
  '/support_/reports': typeof SupportReportsRoute
  '/support_/settings': typeof SupportSettingsRoute
  '/calibrations/': typeof CalibrationsIndexRoute
  '/devices/': typeof DevicesIndexRoute
  '/experiments/': typeof ExperimentsIndexRoute
  '/deployments_/$deploymentId_/adopt': typeof DeploymentsDeploymentIdAdoptRoute
  '/devices_/$deviceId/topology': typeof DevicesDeviceIdTopologyRoute
  '/support_/cases/$caseId': typeof SupportCasesCaseIdRoute
  '/deployments_/$deploymentId_/versions/$versionId': typeof DeploymentsDeploymentIdVersionsVersionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/api-keys'
    | '/auth'
    | '/configuration'
    | '/customers'
    | '/dashboard'
    | '/deployments'
    | '/devices'
    | '/experiments'
    | '/oauth-consent'
    | '/organizations'
    | '/profile'
    | '/projects'
    | '/psychrometrics'
    | '/settings'
    | '/sim-cards'
    | '/support'
    | '/system-health'
    | '/users'
    | '/calibrations/$calibrationId'
    | '/customers/contacts'
    | '/customers/$customerId'
    | '/deployments/$deploymentId'
    | '/deployments/adoption'
    | '/deployments/new'
    | '/devices/$deviceId'
    | '/devices/lorawan'
    | '/devices/xtel'
    | '/devices/return-to-stock'
    | '/experiments/climate-loop'
    | '/experiments/climate-tapestry'
    | '/experiments/comfort-streams'
    | '/experiments/live-network'
    | '/experiments/region-postcards'
    | '/experiments/seasonal-climate'
    | '/projects/$projectId'
    | '/support/reports'
    | '/support/settings'
    | '/calibrations/'
    | '/devices/'
    | '/experiments/'
    | '/deployments/$deploymentId/adopt'
    | '/devices/$deviceId/topology'
    | '/support/cases/$caseId'
    | '/deployments/$deploymentId/versions/$versionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/api-keys'
    | '/auth'
    | '/configuration'
    | '/customers'
    | '/dashboard'
    | '/deployments'
    | '/oauth-consent'
    | '/organizations'
    | '/profile'
    | '/projects'
    | '/psychrometrics'
    | '/settings'
    | '/sim-cards'
    | '/support'
    | '/system-health'
    | '/users'
    | '/calibrations/$calibrationId'
    | '/customers/contacts'
    | '/customers/$customerId'
    | '/deployments/$deploymentId'
    | '/deployments/adoption'
    | '/deployments/new'
    | '/devices/$deviceId'
    | '/devices/lorawan'
    | '/devices/xtel'
    | '/devices/return-to-stock'
    | '/experiments/climate-loop'
    | '/experiments/climate-tapestry'
    | '/experiments/comfort-streams'
    | '/experiments/live-network'
    | '/experiments/region-postcards'
    | '/experiments/seasonal-climate'
    | '/projects/$projectId'
    | '/support/reports'
    | '/support/settings'
    | '/calibrations'
    | '/devices'
    | '/experiments'
    | '/deployments/$deploymentId/adopt'
    | '/devices/$deviceId/topology'
    | '/support/cases/$caseId'
    | '/deployments/$deploymentId/versions/$versionId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/api-keys'
    | '/auth'
    | '/configuration'
    | '/customers'
    | '/dashboard'
    | '/deployments'
    | '/devices'
    | '/experiments'
    | '/oauth-consent'
    | '/organizations'
    | '/profile'
    | '/projects'
    | '/psychrometrics'
    | '/settings'
    | '/sim-cards'
    | '/support'
    | '/system-health'
    | '/users'
    | '/calibrations/$calibrationId'
    | '/customers/contacts'
    | '/customers_/$customerId'
    | '/deployments_/$deploymentId'
    | '/deployments_/adoption'
    | '/deployments_/new'
    | '/devices/$deviceId'
    | '/devices/lorawan'
    | '/devices/xtel'
    | '/devices_/return-to-stock'
    | '/experiments/climate-loop'
    | '/experiments/climate-tapestry'
    | '/experiments/comfort-streams'
    | '/experiments/live-network'
    | '/experiments/region-postcards'
    | '/experiments/seasonal-climate'
    | '/projects_/$projectId'
    | '/support_/reports'
    | '/support_/settings'
    | '/calibrations/'
    | '/devices/'
    | '/experiments/'
    | '/deployments_/$deploymentId_/adopt'
    | '/devices_/$deviceId/topology'
    | '/support_/cases/$caseId'
    | '/deployments_/$deploymentId_/versions/$versionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  ApiKeysRoute: typeof ApiKeysRoute
  AuthRoute: typeof AuthRoute
  ConfigurationRoute: typeof ConfigurationRoute
  CustomersRoute: typeof CustomersRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  DeploymentsRoute: typeof DeploymentsRoute
  DevicesRoute: typeof DevicesRouteWithChildren
  ExperimentsRoute: typeof ExperimentsRouteWithChildren
  OauthConsentRoute: typeof OauthConsentRoute
  OrganizationsRoute: typeof OrganizationsRoute
  ProfileRoute: typeof ProfileRoute
  ProjectsRoute: typeof ProjectsRoute
  PsychrometricsRoute: typeof PsychrometricsRoute
  SettingsRoute: typeof SettingsRoute
  SimCardsRoute: typeof SimCardsRoute
  SupportRoute: typeof SupportRoute
  SystemHealthRoute: typeof SystemHealthRoute
  UsersRoute: typeof UsersRoute
  CalibrationsCalibrationIdRoute: typeof CalibrationsCalibrationIdRoute
  CustomersCustomerIdRoute: typeof CustomersCustomerIdRoute
  DeploymentsDeploymentIdRoute: typeof DeploymentsDeploymentIdRoute
  DeploymentsAdoptionRoute: typeof DeploymentsAdoptionRoute
  DeploymentsNewRoute: typeof DeploymentsNewRoute
  DevicesReturnToStockRoute: typeof DevicesReturnToStockRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  SupportReportsRoute: typeof SupportReportsRoute
  SupportSettingsRoute: typeof SupportSettingsRoute
  CalibrationsIndexRoute: typeof CalibrationsIndexRoute
  DeploymentsDeploymentIdAdoptRoute: typeof DeploymentsDeploymentIdAdoptRoute
  DevicesDeviceIdTopologyRoute: typeof DevicesDeviceIdTopologyRoute
  SupportCasesCaseIdRoute: typeof SupportCasesCaseIdRoute
  DeploymentsDeploymentIdVersionsVersionIdRoute: typeof DeploymentsDeploymentIdVersionsVersionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-health': {
      id: '/system-health'
      path: '/system-health'
      fullPath: '/system-health'
      preLoaderRoute: typeof SystemHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sim-cards': {
      id: '/sim-cards'
      path: '/sim-cards'
      fullPath: '/sim-cards'
      preLoaderRoute: typeof SimCardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/psychrometrics': {
      id: '/psychrometrics'
      path: '/psychrometrics'
      fullPath: '/psychrometrics'
      preLoaderRoute: typeof PsychrometricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations': {
      id: '/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth-consent': {
      id: '/oauth-consent'
      path: '/oauth-consent'
      fullPath: '/oauth-consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments': {
      id: '/experiments'
      path: '/experiments'
      fullPath: '/experiments'
      preLoaderRoute: typeof ExperimentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices': {
      id: '/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof DevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployments': {
      id: '/deployments'
      path: '/deployments'
      fullPath: '/deployments'
      preLoaderRoute: typeof DeploymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration': {
      id: '/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof ConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-keys': {
      id: '/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof ApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/': {
      id: '/experiments/'
      path: '/'
      fullPath: '/experiments/'
      preLoaderRoute: typeof ExperimentsIndexRouteImport
      parentRoute: typeof ExperimentsRoute
    }
    '/devices/': {
      id: '/devices/'
      path: '/'
      fullPath: '/devices/'
      preLoaderRoute: typeof DevicesIndexRouteImport
      parentRoute: typeof DevicesRoute
    }
    '/calibrations/': {
      id: '/calibrations/'
      path: '/calibrations'
      fullPath: '/calibrations/'
      preLoaderRoute: typeof CalibrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support_/settings': {
      id: '/support_/settings'
      path: '/support/settings'
      fullPath: '/support/settings'
      preLoaderRoute: typeof SupportSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support_/reports': {
      id: '/support_/reports'
      path: '/support/reports'
      fullPath: '/support/reports'
      preLoaderRoute: typeof SupportReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects_/$projectId': {
      id: '/projects_/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/seasonal-climate': {
      id: '/experiments/seasonal-climate'
      path: '/seasonal-climate'
      fullPath: '/experiments/seasonal-climate'
      preLoaderRoute: typeof ExperimentsSeasonalClimateRouteImport
      parentRoute: typeof ExperimentsRoute
    }
    '/experiments/region-postcards': {
      id: '/experiments/region-postcards'
      path: '/region-postcards'
      fullPath: '/experiments/region-postcards'
      preLoaderRoute: typeof ExperimentsRegionPostcardsRouteImport
      parentRoute: typeof ExperimentsRoute
    }
    '/experiments/live-network': {
      id: '/experiments/live-network'
      path: '/live-network'
      fullPath: '/experiments/live-network'
      preLoaderRoute: typeof ExperimentsLiveNetworkRouteImport
      parentRoute: typeof ExperimentsRoute
    }
    '/experiments/comfort-streams': {
      id: '/experiments/comfort-streams'
      path: '/comfort-streams'
      fullPath: '/experiments/comfort-streams'
      preLoaderRoute: typeof ExperimentsComfortStreamsRouteImport
      parentRoute: typeof ExperimentsRoute
    }
    '/experiments/climate-tapestry': {
      id: '/experiments/climate-tapestry'
      path: '/climate-tapestry'
      fullPath: '/experiments/climate-tapestry'
      preLoaderRoute: typeof ExperimentsClimateTapestryRouteImport
      parentRoute: typeof ExperimentsRoute
    }
    '/experiments/climate-loop': {
      id: '/experiments/climate-loop'
      path: '/climate-loop'
      fullPath: '/experiments/climate-loop'
      preLoaderRoute: typeof ExperimentsClimateLoopRouteImport
      parentRoute: typeof ExperimentsRoute
    }
    '/devices_/return-to-stock': {
      id: '/devices_/return-to-stock'
      path: '/devices/return-to-stock'
      fullPath: '/devices/return-to-stock'
      preLoaderRoute: typeof DevicesReturnToStockRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices/xtel': {
      id: '/devices/xtel'
      path: '/xtel'
      fullPath: '/devices/xtel'
      preLoaderRoute: typeof DevicesXtelRouteImport
      parentRoute: typeof DevicesRoute
    }
    '/devices/lorawan': {
      id: '/devices/lorawan'
      path: '/lorawan'
      fullPath: '/devices/lorawan'
      preLoaderRoute: typeof DevicesLorawanRouteImport
      parentRoute: typeof DevicesRoute
    }
    '/devices/$deviceId': {
      id: '/devices/$deviceId'
      path: '/$deviceId'
      fullPath: '/devices/$deviceId'
      preLoaderRoute: typeof DevicesDeviceIdRouteImport
      parentRoute: typeof DevicesRoute
    }
    '/deployments_/new': {
      id: '/deployments_/new'
      path: '/deployments/new'
      fullPath: '/deployments/new'
      preLoaderRoute: typeof DeploymentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployments_/adoption': {
      id: '/deployments_/adoption'
      path: '/deployments/adoption'
      fullPath: '/deployments/adoption'
      preLoaderRoute: typeof DeploymentsAdoptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployments_/$deploymentId': {
      id: '/deployments_/$deploymentId'
      path: '/deployments/$deploymentId'
      fullPath: '/deployments/$deploymentId'
      preLoaderRoute: typeof DeploymentsDeploymentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers_/$customerId': {
      id: '/customers_/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof CustomersCustomerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/contacts': {
      id: '/customers/contacts'
      path: '/contacts'
      fullPath: '/customers/contacts'
      preLoaderRoute: typeof CustomersContactsRouteImport
      parentRoute: typeof CustomersRoute
    }
    '/calibrations/$calibrationId': {
      id: '/calibrations/$calibrationId'
      path: '/calibrations/$calibrationId'
      fullPath: '/calibrations/$calibrationId'
      preLoaderRoute: typeof CalibrationsCalibrationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support_/cases/$caseId': {
      id: '/support_/cases/$caseId'
      path: '/support/cases/$caseId'
      fullPath: '/support/cases/$caseId'
      preLoaderRoute: typeof SupportCasesCaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices_/$deviceId/topology': {
      id: '/devices_/$deviceId/topology'
      path: '/devices/$deviceId/topology'
      fullPath: '/devices/$deviceId/topology'
      preLoaderRoute: typeof DevicesDeviceIdTopologyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployments_/$deploymentId_/adopt': {
      id: '/deployments_/$deploymentId_/adopt'
      path: '/deployments/$deploymentId/adopt'
      fullPath: '/deployments/$deploymentId/adopt'
      preLoaderRoute: typeof DeploymentsDeploymentIdAdoptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployments_/$deploymentId_/versions/$versionId': {
      id: '/deployments_/$deploymentId_/versions/$versionId'
      path: '/deployments/$deploymentId/versions/$versionId'
      fullPath: '/deployments/$deploymentId/versions/$versionId'
      preLoaderRoute: typeof DeploymentsDeploymentIdVersionsVersionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface CustomersRouteChildren {
  CustomersContactsRoute: typeof CustomersContactsRoute
}

const CustomersRouteChildren: CustomersRouteChildren = {
  CustomersContactsRoute: CustomersContactsRoute,
}

const CustomersRouteWithChildren = CustomersRoute._addFileChildren(
  CustomersRouteChildren,
)

interface DevicesRouteChildren {
  DevicesDeviceIdRoute: typeof DevicesDeviceIdRoute
  DevicesLorawanRoute: typeof DevicesLorawanRoute
  DevicesXtelRoute: typeof DevicesXtelRoute
  DevicesIndexRoute: typeof DevicesIndexRoute
}

const DevicesRouteChildren: DevicesRouteChildren = {
  DevicesDeviceIdRoute: DevicesDeviceIdRoute,
  DevicesLorawanRoute: DevicesLorawanRoute,
  DevicesXtelRoute: DevicesXtelRoute,
  DevicesIndexRoute: DevicesIndexRoute,
}

const DevicesRouteWithChildren =
  DevicesRoute._addFileChildren(DevicesRouteChildren)

interface ExperimentsRouteChildren {
  ExperimentsClimateLoopRoute: typeof ExperimentsClimateLoopRoute
  ExperimentsClimateTapestryRoute: typeof ExperimentsClimateTapestryRoute
  ExperimentsComfortStreamsRoute: typeof ExperimentsComfortStreamsRoute
  ExperimentsLiveNetworkRoute: typeof ExperimentsLiveNetworkRoute
  ExperimentsRegionPostcardsRoute: typeof ExperimentsRegionPostcardsRoute
  ExperimentsSeasonalClimateRoute: typeof ExperimentsSeasonalClimateRoute
  ExperimentsIndexRoute: typeof ExperimentsIndexRoute
}

const ExperimentsRouteChildren: ExperimentsRouteChildren = {
  ExperimentsClimateLoopRoute: ExperimentsClimateLoopRoute,
  ExperimentsClimateTapestryRoute: ExperimentsClimateTapestryRoute,
  ExperimentsComfortStreamsRoute: ExperimentsComfortStreamsRoute,
  ExperimentsLiveNetworkRoute: ExperimentsLiveNetworkRoute,
  ExperimentsRegionPostcardsRoute: ExperimentsRegionPostcardsRoute,
  ExperimentsSeasonalClimateRoute: ExperimentsSeasonalClimateRoute,
  ExperimentsIndexRoute: ExperimentsIndexRoute,
}

const ExperimentsRouteWithChildren = ExperimentsRoute._addFileChildren(
  ExperimentsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  ApiKeysRoute: ApiKeysRoute,
  AuthRoute: AuthRoute,
  ConfigurationRoute: ConfigurationRoute,
  CustomersRoute: CustomersRouteWithChildren,
  DashboardRoute: DashboardRoute,
  DeploymentsRoute: DeploymentsRoute,
  DevicesRoute: DevicesRouteWithChildren,
  ExperimentsRoute: ExperimentsRouteWithChildren,
  OauthConsentRoute: OauthConsentRoute,
  OrganizationsRoute: OrganizationsRoute,
  ProfileRoute: ProfileRoute,
  ProjectsRoute: ProjectsRoute,
  PsychrometricsRoute: PsychrometricsRoute,
  SettingsRoute: SettingsRoute,
  SimCardsRoute: SimCardsRoute,
  SupportRoute: SupportRoute,
  SystemHealthRoute: SystemHealthRoute,
  UsersRoute: UsersRoute,
  CalibrationsCalibrationIdRoute: CalibrationsCalibrationIdRoute,
  CustomersCustomerIdRoute: CustomersCustomerIdRoute,
  DeploymentsDeploymentIdRoute: DeploymentsDeploymentIdRoute,
  DeploymentsAdoptionRoute: DeploymentsAdoptionRoute,
  DeploymentsNewRoute: DeploymentsNewRoute,
  DevicesReturnToStockRoute: DevicesReturnToStockRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  SupportReportsRoute: SupportReportsRoute,
  SupportSettingsRoute: SupportSettingsRoute,
  CalibrationsIndexRoute: CalibrationsIndexRoute,
  DeploymentsDeploymentIdAdoptRoute: DeploymentsDeploymentIdAdoptRoute,
  DevicesDeviceIdTopologyRoute: DevicesDeviceIdTopologyRoute,
  SupportCasesCaseIdRoute: SupportCasesCaseIdRoute,
  DeploymentsDeploymentIdVersionsVersionIdRoute:
    DeploymentsDeploymentIdVersionsVersionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
